import Immutable from 'immutable';
import { Color, RawColor } from 'records/Color';
import { DocId } from 'records/Doc';
import { Point, RawPoint } from 'records/Point';
import { pointInPolygon } from 'utils/hitDetection';

export type SpaceId = string;

export interface RawSpace {
  spaceid: SpaceId;
  pageid: string;
  documentid: DocId;
  pageIndex: number;
  title: string;
  path: RawPoint[];
  color: RawColor;
  opacity: number; // float
}

export interface SpaceData {
  spaceid: SpaceId;
  pageid: string;
  documentid: DocId;
  pageIndex: number;
  title: string;
  path: Immutable.List<Point>;
  color: Color;
  opacity: number; // float
}

const defaultValues: SpaceData = {
  spaceid: '',
  pageid: '',
  documentid: '',
  pageIndex: 0,
  title: '',
  path: Immutable.List<Point>(),
  color: new Color(),
  opacity: 1.0,
};

export const SpaceFactory = Immutable.Record(defaultValues, 'Space');

// export type Space = Immutable.Record<SpaceData> & Readonly<SpaceData>;

export class Space extends SpaceFactory {
  static deserialize(rawSpace: RawSpace): Space {
    return new Space({
      ...rawSpace,
      path: Immutable.List(rawSpace.path.map(Point.deserialize)),
      color: Color.deserialize(rawSpace.color),
    });
  }

  serialize(item: Space): RawSpace {
    return item.toJS();
  }

  pointInSpace(x: number, y: number): boolean {
    const p = this.path.map((pp) => pp.points).toArray();

    return pointInPolygon(x, y, p);
  }
}

export type SpaceList = Immutable.List<Space>;

export type SpaceMap = Immutable.OrderedMap<SpaceId, Space>;
